export const profilesIds = {
  ADMIN: '07a94f0b-a51d-42c7-8725-bf2289f83e74',
  HUMAN_RESOURCES: '2b3c4d5e-6f7a-4b9c-8d1e-a2b3c4d5e6f7',
  COMMERCIAL: '3c4d5e6f-7a8b-4c9d-8e2f-b3c4d5e6f7a8',
  SERVICE_WORK_COORDINATOR: '4d5e6f7a-8b9c-4d0e-8f3a-c4d5e6f7a8b9',
  TST: '5e6f7a8b-9c0d-4e1f-8a4b-d5e6f7a8b9c0',
  EMPLOYEE: '6f7a8b9c-0d1e-4f2a-8b5c-e6f7a8b9c0d1',
};
